
(function () {
  const DEFAULT_ICON = 'ⓘ';

  // Create (or reuse) the global registry
  window.MAGMA_INFO = window.MAGMA_INFO || {
    configs: [],
    register(cfg) {
      if (!cfg || !cfg.scope || !cfg.onClick) {
        console.warn('[MAGMA_INFO] Missing required fields: scope, onClick', cfg);
        return;
      }
      this.configs.push(cfg);
    }
  };

  function resolveHandler(handler) {
    if (typeof handler === 'function') return handler;
    if (typeof handler === 'string') return window[handler];
    return null;
  }

  function normalize(cfg) {
    return {
      scope: cfg.scope,
      icon: cfg.icon || DEFAULT_ICON,
      onClick: cfg.onClick,
      ariaLabel: cfg.ariaLabel || 'More information',
      payload: cfg.payload ?? null,

      // Optional filters
      // If provided, must return true to allow the click to trigger
      matchScope: typeof cfg.matchScope === 'function' ? cfg.matchScope : null,
      matchAnchor: typeof cfg.matchAnchor === 'function' ? cfg.matchAnchor : null
    };
  }

  // ONE delegated click handler for the whole page
  document.addEventListener(
    'click',
    (e) => {
      const rawCfgs = window.MAGMA_INFO?.configs || [];
      if (!rawCfgs.length) return;

      // Fast exit: only care about clicks on/inside an <a>
      const a = e.target.closest('a');
      if (!a) return;

      // Common Shopify editor behavior: adds target/_blank and rel, but keeps href="#"
      // We only intercept "hash-only" anchors, not real links
      const href = (a.getAttribute('href') || '').trim();
      if (href !== '#') return;

      // Find the first config whose scope contains this anchor
      for (let i = 0; i < rawCfgs.length; i++) {
        const cfg = normalize(rawCfgs[i]);

        const scopeEl = e.target.closest(cfg.scope);
        if (!scopeEl) continue;                 // click not inside this scope
        if (!scopeEl.contains(a)) continue;     // safety

        // Optional filter on the scope element
        if (cfg.matchScope && cfg.matchScope(scopeEl) === false) continue;

        // Optional filter on the anchor element
        if (cfg.matchAnchor && cfg.matchAnchor(a) === false) continue;

        // Only trigger if the anchor text is exactly the icon
        // (prevents hijacking other href="#" links)
        const txt = (a.textContent || '').trim();
        if (txt !== cfg.icon) continue;

        const handler = resolveHandler(cfg.onClick);
        if (typeof handler !== 'function') {
          console.warn('[MAGMA_INFO] handler missing:', cfg.onClick);
          return;
        }

        // Stop navigation + stop other click handlers
        e.preventDefault();
        e.stopPropagation();

        handler({
          event: e,
          anchor: a,
          scope: scopeEl,
          payload: cfg.payload,
          config: cfg
        });

        return; // handle once
      }
    },
    true // capture: helps beat other handlers and prevents new-tab navigation
  );
})();